module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// d:/xampp/htdocs/zenith-admin/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 0